import { useEffect, useState } from "react";
import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";

import { type CarouselApi } from "@/components/ui/carousel";

import aboutUsImage from "@/assets/images/about-us-history.jpeg";
import yearOne from "@/assets/images/history.jpg";
import yearTwo from "@/assets/images/property.jpg";
import whiteLogo from "@/assets/images/white-logo.png";

import LocationBox from "../shared/location-box";

interface TimelineData {
  year: number;
  image: string;
  location: MessageDescriptor;
  visitors: MessageDescriptor;
  description: MessageDescriptor;
  tags: MessageDescriptor[];
}

const timelineData: TimelineData[] = [
  {
    year: 2010,
    image: yearOne,
    location: msg`El Safwa Maadi Palace · Maadi`,
    visitors: msg`300+`,
    description: msg`Born from a seaside dream, our story began with a passion for hospitality and nature, creating a haven where guests can relax, reconnect, and feel at home.`,
    tags: [msg`The beginning`, msg`Who we are`],
  },
  {
    year: 2011,
    image: yearTwo,
    location: msg`El Safwa Maadiii Palace · Maadi`,
    visitors: msg`300+`,
    description: msg`Born from a seaside dream, our story began with a passion for hospitality and nature, creating a haven where guests can relax, reconnect, and feel at home.`,
    tags: [msg`The beginning`, msg`Who we are`],
  },
];

export default function CompanyHistory() {
  const { i18n } = useLingui();
  const [api] = useState<CarouselApi>();
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentItem = timelineData[currentIndex];

  useEffect(() => {
    if (!api) return;

    setCurrentIndex(api.selectedScrollSnap());

    api.on("select", () => {
      setCurrentIndex(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <section className="mx-auto grid grid-cols-1 overflow-hidden rounded-4xl bg-(--color-bg-color-bg-green) md:grid-cols-2 lg:gap-14">
      {/* Content section */}
      <div className="xs:order-1 flex w-full flex-col justify-evenly space-y-6 p-8 md:order-2">
        <div className="flex justify-between">
          <h2 className="text-4xl text-(--color-bg-color-bg-beige) lg:text-5xl">
            <Trans>
              Where <span className="md:block lg:font-medium">It All Started</span>
            </Trans>
          </h2>
          <img
            width={82}
            height={82}
            loading="lazy"
            src={whiteLogo}
            alt="El Safwa Logo"
            className="mb-4 hidden aspect-82/82 lg:block"
          />
        </div>

        <div className="flex flex-col gap-4">
          <div>
            <p className="text-2xl font-semibold text-white">Building Trust Since 1996</p>
            <p className="mt-2 text-sm text-(--color-bg-color-bg-dark-beige)">
              <Trans>
                Our turning point came in 1996 with the creation of Maadi Palace—a bold, visionary
                project blending serviced apartments, rooftop fitness, retail shops, and office
                spaces under one roof. It introduced a new concept to Egypt’s real estate market:
                multi-function living spaces tailored to the needs of a growing expat community.
                Maadi Palace went on to be named one of Egypt’s top 100 buildings in the past 150
                years.
              </Trans>
            </p>
          </div>
        </div>
      </div>

      {/* Image section */}
      <div className="xs:order-2 relative h-[450px] w-full md:order-1 lg:h-[688px]">
        <img
          key={currentItem.image}
          src={aboutUsImage}
          alt={i18n._(currentItem.location)}
          className="animate-in fade-in h-full w-full object-cover duration-1000"
          loading="lazy"
        />
        {/* <div className="overlay_gradient absolute inset-0 overflow-hidden" /> */}
        <div className="absolute bottom-0 p-8">
          <LocationBox
            location={i18n._(currentItem.location)}
            hideVisitors
            // visitors={i18n._(currentItem.visitors)}
          />
        </div>
      </div>
    </section>
  );
}
